import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _stripTags from "../functions/quill/stripTags.js";
import _Speaker from "../classes/speaker.js";
import _Event from "../classes/event.js";
import _tcLib from "../lib/timecode.js";
const tcLib = _tcLib;
const Event = _Event;
const Speaker = _Speaker;
const stripTags = _stripTags;
const convertToHtml = _convertToHtml;
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
import ExcelJs from 'exceljs';
export default {
  decode: async function (input, options) {
    let events = [],
      speakers = [];
    let inputJson = JSON.parse(input);
    inputJson.sheets.forEach(sheet => {
      // Detect column configuration from header row
      let headerRow = sheet.rows[0];
      let columnMap = {};
      if (headerRow && headerRow.cells) {
        headerRow.cells.forEach(cell => {
          let cellCol = cell.address.charAt(0).toUpperCase();
          let headerValue = cell.value ? cell.value.toLowerCase() : '';
          if (headerValue.includes('event') && headerValue.length < 10) {
            columnMap.eventNumber = cellCol;
          } else if (headerValue.includes('timecode in') || headerValue.includes('tc in')) {
            columnMap.tcIn = cellCol;
          } else if (headerValue.includes('timecode out') || headerValue.includes('tc out')) {
            columnMap.tcOut = cellCol;
          } else if (headerValue.includes('frame count in')) {
            columnMap.frameCountIn = cellCol;
          } else if (headerValue.includes('frame count out')) {
            columnMap.frameCountOut = cellCol;
          } else if (headerValue.includes('character')) {
            columnMap.character = cellCol;
          } else if (headerValue.includes('event') && headerValue.length > 10) {
            columnMap.event = cellCol;
          } else if (headerValue.includes('on-screen') || headerValue.includes('note')) {
            columnMap.notes = cellCol;
          }
        });
      }
      sheet.rows.forEach((row, rowIndex) => {
        // Skip header row
        if (rowIndex === 0) return;
        let ccEvent = new Event();
        row.cells.forEach(cell => {
          try {
            let cellCol = cell.address.charAt(0).toUpperCase();

            // Use SMPTE timecode if available
            if (columnMap.tcIn && cellCol === columnMap.tcIn) {
              ccEvent.start = tcLib.tcToSec(cell.value.replace(".", ":"), options.frameRate, options.dropFrame);
            } else if (columnMap.tcOut && cellCol === columnMap.tcOut) {
              ccEvent.end = tcLib.tcToSec(cell.value.replace(".", ":"), options.frameRate, options.dropFrame);
            }
            // Fall back to frame count if SMPTE TC not available
            else if (!columnMap.tcIn && columnMap.frameCountIn && cellCol === columnMap.frameCountIn) {
              ccEvent.start = tcLib.framesToSec(parseInt(cell.value) || 0, options.frameRate);
            } else if (!columnMap.tcOut && columnMap.frameCountOut && cellCol === columnMap.frameCountOut) {
              ccEvent.end = tcLib.framesToSec(parseInt(cell.value) || 0, options.frameRate);
            }
            // Character/Speaker column
            else if (columnMap.character && cellCol === columnMap.character) {
              let speakerArray = cell.value.split(',');
              speakerArray.forEach(speaker => {
                let existingSpeaker = speakers.find(s => s.name === speaker);
                if (existingSpeaker) {
                  ccEvent.speakers.push(existingSpeaker);
                } else {
                  let newSpeaker = new Speaker({
                    name: speaker
                  });
                  speakers.push(newSpeaker);
                  ccEvent.speakers.push(newSpeaker);
                }
              });
            }
            // Event text column
            else if (columnMap.event && cellCol === columnMap.event) {
              ccEvent.text = cell.value;
            }
            // Notes column
            else if (columnMap.notes && cellCol === columnMap.notes) {
              ccEvent.notes = cell.value;
            }
          } catch (err) {
            console.log(err.message);
          }
        });
        if (ccEvent.start !== undefined) {
          ccEvent.text = convertToHtml(ccEvent.text || "");
          events.push(ccEvent);
        }
      });
    });
    return events;
  },
  encode: async function (eventGroup, options) {
    let output,
      encodingOptions = getFormatOptions(options.formatOptions);
    let includeSmpteTc = encodingOptions["Include SMPTE Timestamps"] && encodingOptions["Include SMPTE Timestamps"] === 'yes' ? true : false;
    let includeFrameCount = encodingOptions["Include Frame Count"] && encodingOptions["Include Frame Count"] === 'yes' ? true : false;
    let frameCountRate = encodingOptions["Frame Count Rate"] || 'match';
    let frameCountOffset = parseInt(encodingOptions["Frame Offset"]) || 0;
    frameCountRate = frameCountRate === 'match' ? options.frameRate : parseFloat(frameCountRate);

    // Build headers dynamically based on options
    let headers = ["Event"];
    if (includeSmpteTc) {
      headers.push("TimeCode In", "TimeCode Out");
    }
    if (includeFrameCount) {
      headers.push("Frame Count In", "Frame Count Out");
    }
    headers.push("Character", "Event", "On-Screen Text");
    let rows = [headers];
    eventGroup.events.forEach((event, index) => {
      let row = [index + 1];

      // Add SMPTE timecode columns if enabled
      if (includeSmpteTc) {
        row.push(tcLib.secToTc(Math.max(0, event.start), options.frameRate, options.dropFrame).replace(/:([^:]*)$/, ".$1"), tcLib.secToTc(Math.max(0, event.end), options.frameRate, options.dropFrame).replace(/:([^:]*)$/, ".$1"));
      }

      // Add Frame Count columns if enabled
      if (includeFrameCount) {
        let frameCountIn = tcLib.secToFrames(Math.max(0, event.start), frameCountRate) + frameCountOffset;
        let frameCountOut = tcLib.secToFrames(Math.max(0, event.end), frameCountRate) + frameCountOffset;
        row.push(frameCountIn, frameCountOut);
      }

      // Add remaining columns
      row.push(event.speakers.map(sp => sp.name).join(","), stripTags(event.text), event.notes);
      rows.push(row);
    });
    const workbook = new ExcelJs.Workbook();
    const worksheet = workbook.addWorksheet("DVW Studio Script");
    worksheet.addRows(rows);
    output = await workbook.xlsx.writeBuffer();
    return output;
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup, true);
    },
    decode: function (input) {
      return input;
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};